import React from "react"
import BaseComponent from "../__application/BaseComponent"
import RewardTimer from "./_RewardTimer"
import StatusNav from "./_StatusNav"
import Billing from "./_Billing"

class Page extends BaseComponent {
  constructor(props) {
    super(props)
  }

  render() {
    return (
        <div className="reg2 new-reg billing-step grid-x grid-margin-x">

          <RewardTimer />

          <div className="reg2-page-title cell medium-12">Your account has been created!</div>

          <div className="cell medium-6">
            <StatusNav step="billing"/>
          </div>

          <div className="cell medium-6">
            <Billing geo_data={this.props.geo_data} />
          </div>
        </div>
      )
  }
}

export default Page
